// Services mock data. Backend: replace via servicesService.getServices()
export const SERVICES = [
  {
    id: "svc-equipment-sales",
    name: "Equipment and Consumables Sales",
    slug: "equipment-sales",
    icon: "PackageCheck",
    short:
      "Supply of reliable laboratory instruments from leading global manufacturers, matched to your application.",
    hero:
      "From water purification systems to balances and glassware washers, we supply laboratory equipment from trusted manufacturers — selected around your application, not a catalogue.",
    highlights: [
      "Curated portfolio from leading global manufacturers",
      "Application-led product selection",
      "Delivery and installation coordination",
      "Guidance from enquiry through to commissioning",
    ],
    body:
      "Athena Scientific supplies a carefully selected range of laboratory equipment from leading global manufacturers. Rather than simply fulfilling orders, we help you choose the right instrument for your workflow, performance and budget — then support the process through delivery, installation and beyond. Add the products you are interested in to your inquiry cart and our team will follow up with recommendations, documentation and next steps.",
  },
  {
    id: "svc-maintenance",
    name: "Service Repair and Preventive Maintenance",
    slug: "preventive-maintenance",
    icon: "Wrench",
    short:
      "Scheduled maintenance programmes that help keep your instruments performing reliably.",
    hero:
      "Keep your laboratory running smoothly with preventive maintenance programmes designed around your equipment and usage.",
    highlights: [
      "Scheduled maintenance visits",
      "Instrument checks and servicing",
      "Consumable and part replacement guidance",
      "Support to help minimise downtime",
    ],
    body:
      "Our preventive maintenance support is designed to help laboratories maintain instrument performance over time. Programmes are tailored to your equipment and operating environment. Contact our team to discuss a maintenance plan for your laboratory.",
  },
  {
    id: "svc-rental",
    name: "Equipment Rental",
    slug: "rental",
    icon: "CalendarClock",
    short:
      "Flexible rental options for laboratory equipment to support short-term and project needs.",
    hero:
      "Flexible laboratory equipment rental to support projects, trials, seasonal demand and evolving requirements.",
    highlights: [
      "Flexible rental arrangements",
      "Support for short-term and project needs",
      "Access to laboratory technologies without capital purchase",
      "Application guidance included",
    ],
    body:
      "Equipment rental gives your laboratory flexible access to scientific instruments when you need them. Talk to our team about rental options that fit your project timeline and application.",
  },
  {
    // Added at the client's request. The copy below is a starting point and is
    // fully editable in the CMS under Services.
    id: "svc-special-deals",
    name: "Special Deals",
    slug: "special-deals",
    icon: "Tag",
    short:
      "Current promotions and limited-time offers on selected laboratory equipment and consumables.",
    hero:
      "Selected equipment and consumables available on promotional terms — updated as new offers become available.",
    highlights: [
      "Time-limited pricing on selected products",
      "Clearance and demonstration units",
      "Bundled equipment and consumable offers",
      "Volume pricing on request",
    ],
    body:
      "Athena Scientific runs periodic promotions on selected laboratory equipment and consumables. Contact our team to find out what is currently available and whether a current offer suits your application and budget.",
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);

// The features surfaced in the "Why Athena Scientific" section.
// Four points, down from seven. Preventive maintenance, after-sales support
// and flexible rental were dropped from this list because the Services
// section further down the same page already covers all three — the page was
// making the same promise twice.
export const WHY_ATHENA = [
  {
    icon: "GraduationCap",
    title: "Technical Expertise",
    text: "Scientific and application knowledge to help you make informed decisions.",
  },
  {
    icon: "ShieldCheck",
    title: "Carefully Selected Technologies",
    text: "Reliable laboratory solutions from established global manufacturers.",
  },
  {
    icon: "Compass",
    title: "Customer-First Approach",
    text: "Recommendations based on your objectives, applications and budget — not simply what's in the catalogue.",
  },
  {
    icon: "Handshake",
    title: "Long-Term Partnership",
    text: "Support throughout the equipment lifecycle, from consultation and installation to maintenance and after-sales service.",
  },
];
